import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLockOpen$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLockOpen extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c21e75a3ce5b318c6fd5793720019bc9ae83ef77', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '389fe2ce5a21e31fcf65981f51b5b4b19dce6a17', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1dd5a6a63affd4dfea01caa359528f6fc9a54a5c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.5 8H15V6.17A4.12 4.12 0 0 0 11.39 2 4 4 0 0 0 7 5.4a.52.52 0 0 0 .5.6H8a.49.49 0 0 0 .49-.4 2.5 2.5 0 0 1 2.73-2.09 2.61 2.61 0 0 1 2.28 2.64V8h-9a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5m-1 9.5h-11v-8h11zm-6.25-2.01V13.8a1.5 1.5 0 1 1 1.5 0v1.69a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-lock-open", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-lock-open"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-lock-open":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLockOpen$1);
            }
            break;
    } });
}

const CosmosIconLockOpen = CosmosIconLockOpen$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLockOpen, defineCustomElement };
